@if (hasVisibleChildren()) { 
  <!-- <span>{{getVisibleChildrenNames()}}</span> -->
  <div class="card-container">
    <ng-container #fieldComponent></ng-container>
  </div>
}